import { trustBadges } from "@/mocks/basetaoData";

export default function HeroSection() {
  return (
    <section className="relative w-full min-h-[620px] md:min-h-[720px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Elegant%20modern%20fashion%20ecommerce%20product%20flatlay%20with%20varied%20clothing%20items%20shoes%20accessories%20bags%20arranged%20artistically%20on%20warm%20cream%20marble%20surface%2C%20soft%20natural%20window%20lighting%20casting%20gentle%20shadows%2C%20editorial%20product%20photography%2C%20sophisticated%20neutral%20composition%2C%20luxury%20boutique%20catalog%20aesthetic%2C%20warm%20ivory%20tones%2C%20high%20detail%20fabric%20textures%2C%20refined%20lifestyle%20display&width=1600&height=900&seq=basetao-hero-v2-2026&orientation=landscape"
          alt="BaseTao Spreadsheet product organization guide with fashion items flatlay"
          title="BaseTao Spreadsheet Guide - Product Organization"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-black/45"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-6 lg:px-10 py-20 md:py-28">
        <div className="max-w-3xl mx-auto text-center">
          <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading font-bold text-white leading-tight mb-6 drop-shadow-md">
            BaseTao Spreadsheet &mdash; The Ultimate Guide For Smarter Shopping Decisions
          </h1>
          <p className="text-base md:text-lg text-white/90 max-w-2xl mx-auto mb-10 leading-relaxed drop-shadow-sm">
            Explore the most complete BaseTao Spreadsheet resource covering product guides, shipping cost analysis, warehouse tips, reviews, discounts, and buyer strategies.
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-12">
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="w-full sm:w-auto inline-flex items-center justify-center px-7 py-3.5 rounded-full bg-white text-foreground-900 text-sm font-semibold hover:bg-background-100 transition-all duration-200 whitespace-nowrap cursor-pointer shadow-lg"
            >
              BaseTao Spreadsheet
              <i className="ri-arrow-right-up-line ml-2 w-4 h-4 flex items-center justify-center"></i>
            </a>
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="w-full sm:w-auto inline-flex items-center justify-center px-7 py-3.5 rounded-full bg-primary-500 text-white text-sm font-semibold hover:bg-primary-600 transition-all duration-200 whitespace-nowrap cursor-pointer"
            >
              Buy It Now
              <i className="ri-shopping-cart-line ml-2 w-4 h-4 flex items-center justify-center"></i>
            </a>
          </div>

          <div className="flex flex-wrap items-center justify-center gap-3 md:gap-5">
            {trustBadges.map((badge) => (
              <span
                key={badge}
                className="inline-flex items-center gap-1.5 px-3.5 py-1.5 rounded-full bg-white/20 backdrop-blur-sm text-white text-xs font-medium whitespace-nowrap"
              >
                <i className="ri-check-line text-xs w-3 h-3 flex items-center justify-center"></i>
                {badge}
              </span>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}